export default __webpack_public_path__ + "static/media/icon-zen-time.7b571e27.svg";